// @flow
import { injectIntl, intlShape } from 'react-intl';

import { Container } from './styles';
import messages from '~/core/domains/schedule/intl';
import PropTypes from 'prop-types';
import * as React from 'react';

MessagesBar.propTypes = {
    intl: intlShape,
    messageId: PropTypes.string
};

function MessagesBar({ intl: { formatMessage }, messageId }) {
    return <Container>{messageId ? formatMessage(messages[messageId]) : ''}</Container>;
}

export default injectIntl(MessagesBar);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/messages-bar/component.js